import { API, deleteRequest, getRequest, putRequest } from '@/api/api';

import { mapNotificationEventType } from './notification-event-types.mappers';
import type {
  BulkUpsertNotificationEventTypeValues,
  NotificationEventType,
  NotificationEventTypeDto,
  UpdateNotificationEventTypeValues,
} from './notification-event-types.types';

export const getNotificationEventTypes = async (): Promise<NotificationEventType[]> => {
  const { data } = await getRequest<NotificationEventTypeDto[]>(
    API.NOTIFICATIONS,
    'notifications/event-types',
  );
  return data.map(mapNotificationEventType);
};

export const updateNotificationEventType = async ({
  eventType,
  type,
}: UpdateNotificationEventTypeValues): Promise<NotificationEventType> => {
  const { data } = await putRequest<NotificationEventTypeDto, unknown>(
    API.NOTIFICATIONS,
    `notifications/event-types/${eventType}`,
    { type },
  );
  return mapNotificationEventType(data);
};

export const bulkUpsertNotificationEventTypes = async ({
  items,
}: BulkUpsertNotificationEventTypeValues): Promise<NotificationEventType[]> => {
  const { data } = await putRequest<NotificationEventTypeDto[], unknown>(
    API.NOTIFICATIONS,
    'notifications/event-types/bulk',
    { items: items.map(({ eventType, type }) => ({ event_type: eventType, type })) },
  );
  return data.map(mapNotificationEventType);
};

export const deleteNotificationEventType = async (eventType: string): Promise<void> => {
  await deleteRequest(API.NOTIFICATIONS, `notifications/event-types/${eventType}`);
};
